module.exports = __webpack_public_path__ + "img/coin.21fec511.png";